import { render, staticRenderFns } from "./PageMainSupportUs.vue?vue&type=template&id=26003b11&scoped=true&"
import script from "./PageMainSupportUs.vue?vue&type=script&lang=js&"
export * from "./PageMainSupportUs.vue?vue&type=script&lang=js&"
import style0 from "./PageMainSupportUs.vue?vue&type=style&index=0&id=26003b11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26003b11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VIcon})
